import React from 'react';
import { withAuth0 } from '@auth0/auth0-react';
import Menu from '@proofpoint/fuse/components/Menu';
//import MenuItem from '@proofpoint/fuse/components/MenuItem';
import MenuItem from '@mui/material/MenuItem';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ColorLens from '@mui/icons-material/ColorLens';
import IconButton from '@proofpoint/fuse/components/IconButton';
import Divider from '@proofpoint/fuse/components/Divider';
import ThemeSwitcher from '@proofpoint/fuse/components/ThemeSwitcher';
import Tooltip from '@mui/material/Tooltip';
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';
import { Avatar } from '@mui/material';
import { displayName } from '../identity';


const AccountMenu = ({ auth0 }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return(<>
    <Tooltip title={displayName(auth0.user)}>
      <IconButton color="secondary" onClick={handleClick}>
        <AccountCircle />
      </IconButton>
    </Tooltip>
    <Menu
      anchorEl={anchorEl}
      open={open}
      id="account-menu"
      onClose={handleClose}
      onClick={handleClose}
    >
      <MenuItem sx={{'& .MuiAvatar-root': { width: 24, height: 24, } }}>
        <ListItemIcon style={{ minWidth: 30}}>
          <Avatar src={auth0.user.picture} alt={displayName(auth0.user)} style={{
            width: 24,
            height: 24,
          }}/>
        </ListItemIcon>
        {displayName(auth0.user)}
      </MenuItem>
      <ThemeSwitcher 
        onClose={handleClose} 
        leftIcon={<ColorLens />} 
        id="theme-switcher"
        classes='theme-switcher'
        slotProps={{
          leftIcon: {
            sx: {
              color: '#f00',
            },
          },
        }}
      />
      <Divider />

      <MenuItem sx={{ '& .MuiMenuItem-root': { width: 30 } }} onClick={() => { auth0.logout({logoutParams: { returnTo: window.location.origin }}); }}>
        <ListItemIcon style={{ minWidth: 30 }}>
          <Logout sx={{ minWidth: 24 }} />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
 </>);
}

export default withAuth0(AccountMenu);

